import { action } from 'typesafe-actions';
import { LanguageTypes } from './types';

export const multipleLanguageRequest = (language: string) =>
  action(LanguageTypes.MULTIPLE_LANGUAGE_RESQUEST, { language });

export const multipleLanguageSuccess = (data: any) =>
  action(LanguageTypes.MULTIPLE_LANGUAGE_SUCCESS, { data });

export const multipleLanguageFailure = () =>
  action(LanguageTypes.MULTIPLE_LANGUAGE_FAILURE, {});

export const setLanguageRequest = (language: string) =>
  action(LanguageTypes.MULTIPLE_LANGUAGE_RESQUEST, { language });

export const setLanguageSuccess = (data: any) =>
  action(LanguageTypes.MULTIPLE_LANGUAGE_SUCCESS, { data });

export const setLanguageFailure = () =>
  action(LanguageTypes.MULTIPLE_LANGUAGE_FAILURE, {});
